import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propShape, propBool, propFunc, propArrayShape, propStr, } from '../../../../../helpers/custom-prop-types';
import ProfessionalUnitHeaderCategories from './ProfessionalUnitHeaderCategories';
const ProfessionalUnitHeader = (props) => {
    const { categories, headerHeightRef, isFixed, onClickCategory, title } = props;
    const titleStyle = isFixed ? { top: headerHeightRef.current } : {};
    return (_jsxs("div", Object.assign({ className: 'content_header' }, { children: [_jsx("h2", Object.assign({ className: clsx('header_title', isFixed && 'is-fixed'), style: titleStyle }, { children: title })), _jsx(ProfessionalUnitHeaderCategories, { categories: categories, onClickCategory: onClickCategory })] })));
};
ProfessionalUnitHeader.propTypes = {
    categories: propArrayShape().isRequired,
    headerHeightRef: propShape().isRequired,
    isFixed: propBool().isRequired,
    onClickCategory: propFunc().isRequired,
    title: propStr().isRequired,
};
export default ProfessionalUnitHeader;
